import React, { useEffect } from "react";
import { Flex, Grid, GridItem, Box } from "@chakra-ui/react";
import { barChartData } from "../data/mock";
import DashboardBarChart from "../components/DashboardBarChart";
import FinancePieChart from "../components/FinancePieChart";
import DasboardCards from "../components/DasboardCards";
import { useDispatch, useSelector } from "react-redux";
import { fetchFinanceDashboard } from "../redux/slices/dashboardSlice";
import AdminDashboardExamReport from "../components/AdminDashboardExamReport";

const FinanceDashboard = () => {
  const dispatch = useDispatch();
  const financeDashboardData = useSelector(
    (state) => state?.dashboard?.financeDashboard
  );

  useEffect(() => {
    dispatch(fetchFinanceDashboard());
  }, [dispatch]);

  const data = [
    {
      name: "Total Amount From Event Application",
      number: financeDashboardData?.eventApplicationTotal     ,
      colors: [],
      pieChartData: [
        
      ],
    },
    {
      name: "Total Amount From Exam Application",
      number: financeDashboardData?.examApplicationTotal      ,
      colors: [],
      pieChartData: [
    
      ],
    },
    {
      name: "Total Amount From Event Application",
      number: 20,
      colors: ["#EFF0F6", "#953B8B"],
      pieChartData: [
        { name: "Members", value: 5000 },
        { name: "Non-members ", value: 5000 },
      ],
    },
  ];

  const memberReportData ={title:"Member Report", color1:"#F86624", color2:"#22CAAD", color3:"#EB3D4D", 
    text1:"Total Members", text2:"Total Non-Members", text3:"Total Old Members", 
    value1:"120,000", value2:"50,000", value3:"5000"
  };


  return (
    <Flex
      flexDirection={"column"}
      gap={"20px"}
      py={"30px"}
      minH={"100vh"}
      px={3}
    >
      <Flex
        gap={5}
        flexDirection={["column", "column", "column", "row"]}
      >
        <Flex
          flexDirection={"column"}
          gap={"20px"}
          py={"30px"}
          px={3}
          w={["100%", "100%", "100%", "70%", "75%"]}
        >
          <Grid
            templateColumns={[
              "repeat(1, 1fr)",
              "repeat(1, 1fr)",
              "repeat(1, 1fr)",
              "repeat(3, 1fr)",
            ]}
            gap={[5, 5, 5, 3]}
          >
            {data?.map((item, index) => (
              <GridItem key={index}>
                <DasboardCards
                  name={item?.name}
                  number={item?.number}
                  colors={item?.colors}
                  pieChartData={item?.pieChartData}
                />
              </GridItem>
            ))}
          </Grid>
          <DashboardBarChart barChartData={barChartData} text1={"Successful"} text2={"Failed"} />
        </Flex>
        <Box mt={7} width={["100%", "100%", "100%", "30%", "25%"]}>
          <FinancePieChart />
        </Box>
      </Flex>
      <DashboardBarChart barChartData={barChartData} title={"Activity Report Per Month"} color1={"#812773"} color2={"#CD73D1"} text1={"Active Members"} text2={"Dormant members"} />
      <AdminDashboardExamReport {...memberReportData} />
    </Flex>
  );
};

export default FinanceDashboard;
